import { mapState, mapGetters, mapActions } from 'vuex'

 
export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}
export const authMethods = mapActions('auth', ['logIn', 'logOut', 'register', 'resetPassword'])

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const authFackMethods = mapActions('authfack', ['login', 'registeruser', 'logout'])

export const notificationMethods = mapActions('notification', ['success', 'error', 'clear'])


export const GenericComputed = {
   ...mapState(
    'auth', {   
      JWToken: (state) => state.JWToken, 
    }),
  ...mapGetters('auth', ['UserNameSurName','TokenPersonelId','TokenPersonelBirimId','TokenUserId','TokenEmail','UserRolles','Avatar','JWToken','UserEMail'])
}

export const MethodsEcampus = mapActions('ecampus', [
  'FastReport',
  'ActionsGet',
  'ActionsSingleGet',
  'ActionsSinglePut',
  'ActionsFilterGet',
  'ActionsPost',
  'ActionsPut',
  'ActionsPutIdsiz',
  'ActionsPutList',
  'ActionsPostList',
  'ActionsDelete',
  'ActionsSabitGet',
  'ActionsDeletePut',  
  'Report'
])
export const MethodsAuth = mapActions('auth', [
  'ActionsLogin',
  'ActionsLoginSessionKey',
  'ActionsSendVerification',
  'ActionsForgotPassword',
  'ActionsResetPassword',
  'ActionsConfirmEmail',
  'TokenZamaniHesaplama',
  'TokenRefreshZamanKontrol',
  'HeaderAvatar',
  'ResetPasswordLogin',
  'ActionsAdminSetPassword',
  'ActionsAdminConfirmEmail'
])
export const MethodsActionsLoginSessionKey = mapActions('auth', [ 
  'ActionsLoginSessionKey', 
])

export const ActionsGet = mapActions('ecampus', ['ActionsGet'])
export const ActionsPut = mapActions('ecampus', ['ActionsPut'])
export const ActionsPost = mapActions('ecampus', ['ActionsPost'])
export const ActionsDelete = mapActions('ecampus', ['ActionsDelete'])
export const ActionsSabitGet = mapActions('ecampus', ['ActionsSabitGet'])
export const ActionsFilterGet = mapActions('ecampus', ['ActionsFilterGet'])
export const ActionsSinglePut = mapActions('ecampus', ['ActionsSinglePut'])